var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-contact-list-tool-bar" }, [
    _c("div", { staticClass: "toolbar-row" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          { staticClass: "status" },
          [
            _c(
              "a-tooltip",
              {
                attrs: {
                  placement: "bottom",
                  title:
                    _vm.$t("chat.gridContactListToolBar.chatStatus") +
                    ": " +
                    _vm.currentStatusFullLabel,
                },
              },
              [
                _c("MinimalPopoverSelect", {
                  attrs: {
                    value: _vm.effectiveState,
                    options: _vm.statusOptions,
                    "show-icon": true,
                    "show-dropdown-arrow": false,
                    "button-class": "chip select-chip",
                    "popover-class": "toolbar-select-popover",
                    "check-icon": "done",
                  },
                  on: { change: _vm.onStatusChange },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c(
            "a-tooltip",
            {
              attrs: {
                placement: "bottom",
                title:
                  _vm.$t("chat.gridContactListToolBar.sortBy") +
                  ": " +
                  _vm.getSortTitle(_vm.selectedSortField),
              },
            },
            [
              _c("MinimalPopoverSelect", {
                attrs: {
                  value: _vm.selectedSortField,
                  options: _vm.sortOptions,
                  "show-icon": true,
                  "show-dropdown-arrow": false,
                  "button-class": "chip select-chip",
                  "popover-class": "toolbar-select-popover",
                  "check-icon": "done",
                },
                on: { change: _vm.onSortFieldChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tooltip",
            {
              attrs: {
                placement: "bottom",
                title:
                  _vm.selectedSortDir === "DESC"
                    ? _vm.$t("chatWindow.descending")
                    : _vm.$t("chatWindow.ascending"),
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "chip chip--icon dir-chip",
                  on: {
                    click: function ($event) {
                      return _vm.toggleSortDir()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(
                      _vm._s(
                        _vm.selectedSortDir === "DESC"
                          ? "arrow_downward"
                          : "arrow_upward"
                      )
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }